import { PlanFieldState } from '@/modules/plan/plan.types';
import { baseStoreCreator } from '@/utils/store';

export interface AdditionalFieldsStatePayload {
  availableBalance: PlanFieldState;
  minimumElectionAmount: PlanFieldState;
  maximumElectionAmount: PlanFieldState;
  proofOfExpense: PlanFieldState;
  proofOfExpensesCardType: PlanFieldState;
  CIPRequired: PlanFieldState;
  CIPAccountClosureDelayDays: PlanFieldState;
  returnFundsAfterCipAccountClosureType: PlanFieldState;
  pendContributionsForCIP: PlanFieldState;
  CMSReportingRequired: PlanFieldState;
  allowInvestments: PlanFieldState;
  catchUpElections: PlanFieldState;
  catchUpAge: PlanFieldState;
  investmentOptionsType: PlanFieldState;
  investmentThreshold: PlanFieldState;
  minimumInvestmentAmount: PlanFieldState;

  aiAdjudicationType: PlanFieldState;
  spendLimit: PlanFieldState;
  totalPlanLimit?: PlanFieldState;
  spendPeriod: PlanFieldState;
  perPersonSpendLimit?: PlanFieldState;
  perCategorySpendLimit?: PlanFieldState;
  isOrphaned: PlanFieldState;
  generateStatements: PlanFieldState;
  ignoreElectionLimit: PlanFieldState;
  includeToBalanceReminder: PlanFieldState;
}

export const DEFAULT_VALUES: AdditionalFieldsStatePayload = {
  isOrphaned: PlanFieldState.Modifiable,
  availableBalance: PlanFieldState.Modifiable,
  minimumElectionAmount: PlanFieldState.Modifiable,
  maximumElectionAmount: PlanFieldState.Modifiable,
  proofOfExpense: PlanFieldState.Modifiable,
  proofOfExpensesCardType: PlanFieldState.Modifiable,
  CIPRequired: PlanFieldState.Modifiable,
  CIPAccountClosureDelayDays: PlanFieldState.Modifiable,
  pendContributionsForCIP: PlanFieldState.Modifiable,
  CMSReportingRequired: PlanFieldState.Modifiable,
  allowInvestments: PlanFieldState.Modifiable,
  catchUpElections: PlanFieldState.Modifiable,
  catchUpAge: PlanFieldState.Modifiable,
  investmentOptionsType: PlanFieldState.Modifiable,
  investmentThreshold: PlanFieldState.Modifiable,
  minimumInvestmentAmount: PlanFieldState.Modifiable,
  generateStatements: PlanFieldState.Modifiable,
  ignoreElectionLimit: PlanFieldState.Modifiable,
  includeToBalanceReminder: PlanFieldState.Modifiable,
  returnFundsAfterCipAccountClosureType: PlanFieldState.Modifiable,

  aiAdjudicationType: PlanFieldState.Modifiable,
  spendLimit: PlanFieldState.Modifiable,
  totalPlanLimit: PlanFieldState.Modifiable,

  spendPeriod: PlanFieldState.Modifiable,
  perPersonSpendLimit: PlanFieldState.Modifiable,
  perCategorySpendLimit: PlanFieldState.Modifiable,
};

export const useStore = baseStoreCreator<AdditionalFieldsStatePayload>(DEFAULT_VALUES);

export default useStore;
